export const isoTypeUstatPostgraduates = {
  "$schema": "https://vega.github.io/schema/vega/v5.json",
  "data": [
    {
      "name": "source_0",
      "values": null,
      "transform": [
        {
          "type": "collect",
          "sort": {
            "field":"year",
            "order": "ascending"
          }
        },
        {
          "type": "extent", 
          "field": "year", 
          "signal": "years_extent"
        },
        {
          "type": "formula",
          "expr": "datum.year >= splitInYear ? 'right':'left'",
          "as": "column"
        }
      ]
    },
    {
      "name": "years_left_column",
      "source": "source_0",
      "transform": [
        {
          "type": "filter",
          "expr": "datum.year < splitInYear"
        },

        {
          "type": "extent",
          "field": "year",
          "signal": "years_left_extent"
        }
      ]
    },
    {
      "name": "years_right_column",
      "source": "source_0",
      "transform": [
        {
          "type": "filter",
          "expr": "datum.year >= splitInYear"
        },
        {
          "type": "extent",
          "field": "year",
          "signal": "years_right_extent"
        }
      ]
    },
    {
      "name": "years_domain",
      "transform": [
        {
          "type": "sequence",
          "start": {
            "signal": "years_left_extent[0]"
          },
          "stop": {
            "signal": "years_left_extent[1]"
          }
        }
      ]
    }    
  ],
  "signals": [
    {
      "name": "width",
      "update": "(containerSize()[0] || 400)",
      "on": [{
          "events": {"source": "window", "type": "resize"},
          "update": "containerSize()[0]"
      }]
    },
    {"name": "child_width", "update": "(width*0.5)/2"},
    {"name": "icon_size", "value": 7},
    {"name": "child_height", "update": "icon_size*4"},
    {"name": "splitInYear", "update": "ceil(years_extent[0] + ((years_extent[1] - years_extent[0]) / 2) + 1)"}
  ],
  "marks": [
    {
      "name": "cell",
      "type": "group",
      "title": {
        "text": {
          "signal": "parent.year"
        },
        "orient": "left",
        "angle": 0
      },
      "from": {
        "facet": {
          "name": "facet", 
          "data": "source_0", 
          "groupby": ["year"]
        }
      },
      
      "encode": {
        "enter": {
          "x": {
            "signal": "scale('column', datum.year < splitInYear? 'left':'right')"
          },
          "y": {
            "signal": "scale(datum.year < splitInYear ? 'row_left' : 'row_right', datum.year)"
          },
          "height": {
            "signal": "child_height"
          }
        },
        "update": {
          "width": {"signal": "child_width"}
        }
      },
      "marks": [        
        {
          "name": "child_marks",
          "type": "symbol",
          "from": {"data": "facet"},
          "encode": {
            "update": {
              "shape": {"signal": "datum.studentType == 'iscritti' ? 'circle' : 'square'" },
              "fill": {"signal": "datum.studentType == 'iscritti' ? '#95894d' : '#9b599e'"},
              "stroke": {"signal": "datum.studentType == 'iscritti' ? '#95894d' : '#9b599e'"},
              "strokeWidth": {"signal": "datum.studentType == 'iscritti' ? 1 : 0"},
              "x": {
                "signal": "datum.col * (icon_size+(icon_size/5))"
              },
              "y": {
                "signal": "datum.studentFlow === 'in'? scale('y', datum.studentFlow) + (icon_size * 2) : scale('y', datum.studentFlow) + (icon_size * 2)"
              }, 
              "size": {"signal": "icon_size*5"}
            }
          }
        },
        {
          "name": "label",
          "type": "text",
          "from": {"data": "facet"},
          "encode": {
            "update": {
              "x": {
                "signal": "datum.col + icon_size / 2"
              },
              "y": {
                "signal": "datum.studentFlow === 'in'? scale('y', datum.studentFlow) + icon_size : scale('y', datum.studentFlow) + (icon_size * 4)"
              },
              "fill": {"value": "#666"},
              "text": {"signal": "datum.col == 1 ? datum.total : ''"}
            }
          }
        }
      ]
    }
  ],
  "scales": [
    {
      "name": "column",
      "type": "point",
      "domain": {
        "data": "source_0",
        "field": "column"
      },
      "range": [0, {"signal": "width * 0.5"}]
    },
    {
      "name": "row_left",
      "type": "point",
      "domain": {
        "data": "years_left_column",
        "field": "year"
      },
      "range": [
        0, 
        {
          "signal": "(years_left_extent[1] - years_left_extent[0]) * (child_height * 2)"
        }
      ]
    },
    {
      "name": "row_right",
      "type": "point",
      "domain": {
        "data": "years_right_column",
        "field": "year"
      },
      "range": [
        0, 
        {
          "signal": "(years_right_extent[1]-years_right_extent[0]) * (child_height * 2)"
        }
      ]
    },
    {
      "name": "x",
      "type": "point",
      "domain": {"data": "source_0", "field": "col", "sort": true},
      "range": [0, {"signal": "width*0.5"}],
      "padding": 0
    },
    {
      "name": "y",
      "type": "point",
      "domain": {"data": "source_0", "field": "studentFlow", "sort": true},
      "range": [0, {"signal": "icon_size*4"}],
      "padding": 1
    }
  ]
}